<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';

import Pagination from '@/components/Pagination';

library.add( faPencilAlt, faTrash, faSpinner );

export default {
  name: 'ModuleUsersEditionInvitationsList',
  components: {
    Pagination,
  },
  computed: {
    ...mapState('invitation/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        const query = Object.assign({}, this.query);

        if (this.course !== null) {
          query.course = this.course;
        }

        this.fetch(query);
      },
    },
  },
  methods: {
    ...mapActions('invitation/collection', [
      'fetchUser',
    ]),
    ...mapMutations('invitation/collection', [
      'setPage',
    ]),
    ...mapActions('invitation/item', [
      'remove',
    ]),
    confirmDelete(item) {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${item.code}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {})
      ;
    },
    getUserFullName(item) {
      const { userfirst_name = null, userlast_name = null } = item;
      return userfirst_name && userlast_name ? `${userfirst_name} ${userlast_name}` : `${userfirst_name || ''}${userlast_name || ''}`;
    },
  },
  created() {
    this.fetchUser(this.$route.params.id);
  },
};
</script>
<template>
  <div class="pt-3 pb-3">
    <div class="d-flex justify-content-between mb-3">
      <h2>Invitations</h2>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'invitations'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th>Code</th>
          <th>Activated At</th>
          <th>Expires At</th>
          <th>Created At</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="!items.length">
        <td colspan="8" class="text-center">
          There are no invitation codes
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td>{{ item.code }}</td>
        <td>{{ item.activatedAt }}</td>
        <td>{{ item.expiresAt }}</td>
        <td>{{ item.createdAt }}</td>
        <td class="w-25">
          <router-link :to="{ name: 'invitations-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
